export default __webpack_public_path__ + "static/media/illustration-contact-page.b6a81187.svg";